import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config.service';
import { MissionsService } from 'src/app/services/missions.service';
import { ToolsService } from 'src/app/services/tools.service';
export class RankingPage {
    constructor(missionService, toolsService, configService) {
        this.missionService = missionService;
        this.toolsService = toolsService;
        this.configService = configService;
        this.groupsArray = [];
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.companyInfo = yield this.configService.company_info;
            this.getPlayerRankingInfo();
        });
    }
    getPlayerRankingInfo() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.toolsService.showLoader();
            const response = yield this.missionService.getRankingByActivity();
            console.log("Ranking", response);
            this.rankingResponse = response;
            this.progress = this.rankingResponse.indicator_position;
            this.groupsArray = this.rankingResponse.groups;
            yield this.toolsService.dismissLoader();
        });
    }
}
